module.exports = __webpack_public_path__ + "img/Hendrik_Schulz.jpg";